import React from 'react';
import { PropTypes } from 'prop-types';
import { GoogleMap, DirectionsRenderer, Marker } from 'react-google-maps';

import { mapOptions, directionsOptions } from './utils';

const europeCenter = { lat: 54.526, lng: 15.2551 };

const Map = ({ stopMarkers, stopDirections, driverMarker }) => (
  <div>
    <GoogleMap
      defaultZoom={4}
      defaultCenter={europeCenter}
      defaultOptions={mapOptions}
    >
      {stopMarkers &&
        stopMarkers.map((marker) => (
          <div key={marker.key}>
            <Marker {...marker} />
          </div>
        ))}
      {driverMarker && (
        <div>
          <Marker key="driver" {...driverMarker} />
        </div>
      )}
      {stopDirections && (
        <div>
          {' '}
          <DirectionsRenderer
            directions={stopDirections}
            defaultOptions={directionsOptions}
          />
        </div>
      )}
    </GoogleMap>
  </div>
);

Map.propTypes = {
  stopDirections: PropTypes.shape({}),
  stopMarkers: PropTypes.arrayOf(PropTypes.shape({})),
  driverMarker: PropTypes.shape({}),
};

Map.defaultProps = {
  stopDirections: {},
  stopMarkers: [],
  driverMarker: {},
};

export default Map;
